import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	setBackgroundClassNames,
	setBackgroundStyles
} from '../utilities/background';
import { isResponsiveImageType } from '../utilities/images';

class Background extends Component {
	constructor(props) {
		super(props);
		this.imageRef = React.createRef();
		this.state = {
			backgroundImage: '/static/images/blank.gif'
		};
	}

	componentDidMount() {
		const image = this.imageRef.current;
		if (image && image.complete) {
			this.updateBackgroundImage();
		}
	}

	updateBackgroundImage() {
		this.setState({
			backgroundImage:
				this.imageRef.current.currentSrc || this.imageRef.current.src
		});
	}

	render() {
		const {
			showImage,
			imageLocation,
			imageUrl,
			imagePosition,
			imageSize,
			backgroundColor,
			backgroundGradient,
			backgroundRepeat,
			backgroundTransitionProperty,
			backgroundTransitionTimingFunction,
			backgroundTransitionDuration,
			foregroundImageCircle,
			foregroundImageHeight,
			foregroundImageWidth,
			foregroundImageMargin,
			foregroundImagePadding,
			foregroundImageAlignment
		} = this.props;
		const { backgroundImage } = this.state;
		const hasBackground =
			showImage === false &&
			imageLocation !== 'foreground' &&
			(backgroundColor !== '' || backgroundGradient !== '');
		const hasResponsiveImage = isResponsiveImageType(
			imageUrl,
			imageLocation
		);

		if (showImage || hasBackground) {
			return (
				<div
					className={setBackgroundClassNames(
						imageLocation,
						foregroundImageCircle,
						foregroundImageMargin,
						foregroundImagePadding,
						foregroundImageAlignment,
						backgroundColor,
						backgroundTransitionProperty,
						backgroundTransitionTimingFunction,
						backgroundTransitionDuration
					)}
					style={setBackgroundStyles(
						showImage,
						imageLocation,
						imageUrl,
						imagePosition,
						imageSize,
						backgroundGradient,
						backgroundRepeat,
						foregroundImageHeight,
						foregroundImageWidth,
						hasResponsiveImage,
						backgroundImage
					)}
				>
					{hasResponsiveImage && (
						<img
							ref={this.imageRef}
							alt=""
							hidden
							role="presentation"
							className="lazy-image dynamic-resize responsive-image d-none"
							data-src={imageUrl}
							onLoad={this.updateBackgroundImage.bind(this)}
						/>
					)}
				</div>
			);
		}
		return null;
	}
}

Background.defaultProps = {
	imageLocation: '',
	imageUrl: '',
	imagePosition: '',
	imageSize: '',
	backgroundColor: '',
	backgroundGradient: '',
	backgroundRepeat: '',
	backgroundTransitionProperty: '',
	backgroundTransitionTimingFunction: '',
	backgroundTransitionDuration: '',
	foregroundImageCircle: false,
	foregroundImageHeight: 0,
	foregroundImageWidth: 0,
	foregroundImageMargin: '',
	foregroundImagePadding: '',
	foregroundImageAlignment: ''
};

Background.propTypes = {
	showImage: PropTypes.bool.isRequired,
	imageLocation: PropTypes.string,
	imageUrl: PropTypes.string,
	imagePosition: PropTypes.string,
	imageSize: PropTypes.string,
	backgroundColor: PropTypes.string,
	backgroundGradient: PropTypes.string,
	backgroundRepeat: PropTypes.string,
	backgroundTransitionProperty: PropTypes.string,
	backgroundTransitionTimingFunction: PropTypes.string,
	backgroundTransitionDuration: PropTypes.string,
	foregroundImageCircle: PropTypes.bool,
	foregroundImageHeight: PropTypes.number,
	foregroundImageWidth: PropTypes.number,
	foregroundImageMargin: PropTypes.string,
	foregroundImagePadding: PropTypes.string,
	foregroundImageAlignment: PropTypes.string
};

export default Background;
